import confModule from "../config";
import serviceHelperModeule from "./helpers/helpers";
import serviceStorageModule from "./storage/storage";


export const serivceModule = angular.module('tdl.services', ['tdl.config', 'tdl.services.helpers', 'tdl.services.storage', 'ngCookies']);

